import React from "react";
import styles from "./Card.module.scss";
import { Icon } from "@me8eon/icons";

interface Props extends React.HTMLAttributes<HTMLButtonElement> {
    children: React.ReactNode,
}

export const Card = (props: Props) => {
    const { children, className, ...rest } = props;
    return (
        <button className={`${styles.card} ${className ?? ""}`} {...rest}>
            <span><Icon name="search_ai" style={{ fill: "#7F8185" }} /></span>
            {children}
        </button>
    )
}